import React, { Component } from "react"
import I18n from "../utils/i18n.js"
import createReactClass from 'create-react-class'
export default createReactClass({
  paginate(page, e) {
    e.preventDefault();
    this.props.onPaginate(page);

    if ($(document.body).css('overflow-y') === 'hidden') {
      return $('.facets-inner').animate(
        {scrollTop: 0}
      , 1500);
    } else {
      return $('html, body').animate(
        {scrollTop: 0}
      , 1500);
    }
  },

  render() {
    const self = this;
    const url = this.props.url.substring(0, this.props.url.indexOf('?'));
    const pagination = [];
    const { page } = this.props;
    const pages = Math.ceil(this.props.total / 20);
    const { position } = this.props;
    const paginationClasses = position === 'top' ? 'pagination pagination--simple pagination-top' : 'pagination pagination--simple';

    if (pages <= 1) { return <div className="pagination"></div>; }

    const prev = page === 1 ? <span className="previous_page disabled"></span> : <a href={url+'?page='+(page-1)} rel="prev" className="previous_page" onClick={self.paginate.bind(self, page - 1)}><div>{I18n.t('search.pagination.prev')}</div></a>;
    const next = page === pages ? <span className="next_page disabled"></span> : <a href={url+'?page='+(page+1)} rel="next" className="next_page" onClick={self.paginate.bind(self, page + 1)}><div>{I18n.t('search.pagination.next')}</div></a>;
    const currentPage = <div>{I18n.t('search.pagination.page', {page, total: pages})}</div>;

    return <div className={paginationClasses}>
      {prev}
      {currentPage}
      {next}
    </div>;
  }
});
